"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// src/data/Products_11.ts
const product_types_1 = require("../types/product.types");
const products = [
    // 1171. Fase 4: Hospitalet - Simulacre d'Entrevista Duo Mossos d'Esquadra 2026 (1:00 hora)
    {
        id: 1171,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE4,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.fase4-simulacre-entrevista-duo-policial-mossos-2027-1h-hospitalet",
        title: "Fase 4: Hospitalet - Simulacre d'Entrevista Duo Mossos d'Esquadra 2027 (1:00 h)",
        name: "Fase 4: Hospitalet - Simulacre d'Entrevista Duo Mossos d'Esquadra 2027 (1:00 h)",
        description: "Una doble avaluació professional que et permet saber exactament com rendiries davant el tribunal real.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        // low_stock_message: "Últimes places disponibles!",
        special_buy: "/tienda/cursos/fase4-hospitalet-simulacre-dentrevista-duo-mossos-2027-1h/#reserva",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 189.99,
        shipment: 0.0,
        images: ["/1171/image1"],
        banner: ["/1171/image1"],
        link: "/tienda/cursos/fase4-hospitalet-simulacre-dentrevista-duo-mossos-2027-1h/",
        created_at: "2026-02-05 00:00:01",
        start_at: "2026-02-05 00:00:01",
        more_info: true,
        items: 1,
        calendly_schedule: [
            {
                id: 1,
                name: "Jordi i Txema",
                position: "Psicòleg col·legiat i Agent CME",
                description: "Rigor, criteri i domini dels barems d'avaluació. - Estràtegia, entrenaments i resultats.",
                location: "C/ Martí Codolar, 18, 08902 L'Hospitalet de Llobregat (Barcelona)",
                link: "https://calendly.com/d/cttt-s37-b2h/fase-4-simulacre-entrevista-duo-mossos-2027-1-h-ho",
            },
            {
                id: 2,
                name: "Jordi i Paco",
                position: "Psicòleg col·legiat i Agent CME",
                description: "Rigor, criteri i domini dels barems d'avaluació. - Estràtegia, entrenaments i resultats.",
                location: "C/ Martí Codolar, 18, 08902 L'Hospitalet de Llobregat (Barcelona)",
                link: "https://calendly.com/d/ctvj-y8s-bt9/fase-4-simulacre-entrevista-duo-mossos-2027-1h-ho-2",
            },
        ],
    },
    // 1172. Revisió Personalitzada de Biodata
    {
        id: 1172,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        hidden: true,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Online,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
        ],
        tax: 0.0,
        sku: "iopos.course.online.revisio-personalitzada-biodata-mossos-2026",
        title: "Revisió Personalitzada de Biodata — Mossos d'Esquadra",
        name: "Revisió Personalitzada de Biodata — Mossos d'Esquadra",
        description: "Servei online de revisió personalitzada del Biodata per a l’oposició de Mossos d’Esquadra. Analitzem les teves respostes, detectem punts febles i t’oferim orientacions concretes per millorar coherència, estructura i impacte.",
        enabled: true,
        stock: true,
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 59.99,
        shipment: 0.0,
        images: ["/1172/image1"],
        banner: ["/1172/image1"],
        link: "/tienda/cursos/revisio-personalitzada-biodata-mossos-2026/",
        created_at: "2026-02-15 00:00:01",
        start_at: "2026-02-15 00:00:01",
        more_info: true,
        items: 1,
    },
    // 1173. Preparació d'Entrevista Preparació Arro o Brimo 2026
    {
        id: 1173,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Online,
            product_types_1.Category.Interviews,
            product_types_1.Category.ARRO,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.classroom.preparacio-entrevista-test-pers-arro-brimo-caporal-2026",
        title: "Preparació d'Entrevista + Test de Personalitat (ARRO, BRIMO o Caporal)",
        name: "Preparació d'Entrevista + Test de Personalitat (ARRO, BRIMO o Caporal)",
        description: "Servei de preparació per a l'entrevista i el test de personalitat (ARRO, BRIMO o Caporal) per a l’oposició de Mossos d’Esquadra. Analitzem les teves respostes, detectem punts febles i t’oferim orientacions concretes per millorar coherència, estructura i impacte.",
        enabled: false,
        stock: false,
        stock_message: "Sense places disponibles",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 199.99,
        shipment: 0.0,
        images: ["/1173/image1"],
        banner: ["/1173/image1"],
        link: "/tienda/cursos/preparacio-entrevista-test-pers-arro-brimo-caporal-2026/",
        created_at: "2026-02-15 00:00:01",
        start_at: "2026-02-15 00:00:01",
        more_info: true,
        items: 1,
    },
    // 1174. Fase 3: Sant Cugat - Simulacre d'Entrevista Mossos d'Esquadra 2026 (1:00 hora)
    {
        id: 1174,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE3,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.fase3-simulacre-entrevista-policial-mossos-2026-1h-sant-cugat",
        title: "Fase 3: Sant Cugat - Simulacre d'Entrevista Mossos d'Esquadra 2026 (1:00 h)",
        name: "Fase 3: Sant Cugat - Simulacre d'Entrevista Mossos d'Esquadra 2026 (1:00 h)",
        description: "Posa a prova el teu perfil en una simulació real d'entrevista i corregeix errors abans que comptin de veritat.",
        enabled: true,
        stock: false,
        stock_message: "Aviat disponible",
        special_buy: "/tienda/cursos/fase3-sant-cugat-simulacre-dentrevista-mossos-2026-1h/#reserva",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/1174/image1"],
        banner: ["/1174/image1"],
        link: "/tienda/cursos/fase3-sant-cugat-simulacre-dentrevista-mossos-2026-1h/",
        created_at: "2026-02-17 00:00:01",
        start_at: "2026-02-17 00:00:01",
        more_info: true,
        items: 1,
        calendly_schedule: [
            {
                id: 1,
                name: "Irene",
                position: "Psicòloga clínica",
                description: "Rigor, criteri i domini dels barems d'avaluació.",
                location: "Avinguda Cerdanyola 73, Sant Cugat del Vallés, Barcelona",
                link: "https://calendly.com/iopos-academia-irene/fase-3-simulacre-entrevista-mossos-2026-1-00-h-sc",
            },
        ],
    },
    // 1175. Fase 1: Preparació d'Entrevista (ARRO, BRIMO o Caporal - 1:30 h)
    {
        id: 1175,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Interviews,
            product_types_1.Category.ARRO,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.classroom.preparacio-entrevista-arro-brimo-caporal-2026-1-30h-ho",
        title: "Fase 1: Preparació d'Entrevista (ARRO, BRIMO o Caporal - 1:30 h)",
        name: "Fase 1: Preparació d'Entrevista (ARRO, BRIMO o Caporal - 1:30 h)",
        description: "Una preparació estratègica i profunda per construir un perfil operatiu o de comandament sòlid, coherent i realment competitiu davant del tribunal.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        special_buy: "/tienda/cursos/fase1-preparacio-entrevista-arro-brimo-caporal-1-30h-2026/#reserva",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 129.99,
        shipment: 0.0,
        images: ["/1175/image1"],
        banner: ["/1175/image1"],
        link: "/tienda/cursos/fase1-preparacio-entrevista-arro-brimo-caporal-1-30h-2026/",
        created_at: "2026-02-15 00:00:01",
        start_at: "2026-02-15 00:00:01",
        more_info: true,
        items: 1,
        calendly_schedule: [
            {
                id: 1,
                name: "Marina",
                position: "Sergenta CME",
                description: "Acompanyament en processos selectius d'ascens i d'especialitat.",
                location: "C/ Martí Codolar, 18, 08902 L'Hospitalet de Llobregat (Barcelona)",
                link: "https://calendly.com/iopos-academia-marina/fase1-preparacio-entrevista-arro-brimo-2026-1-30-h-ho",
            },
        ],
    },
    // 1176. Fase 2: Simulacre d'Entrevista (ARRO, BRIMO o Caporal - 1:00 h)
    {
        id: 1176,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Interviews,
            product_types_1.Category.ARRO,
            product_types_1.Category.FASE2,
        ],
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        sku: "iopos.course.classroom.simulacre-entrevista-arro-brimo-caporal-2026-1-00h-ho",
        title: "Fase 2: Simulacre d'Entrevista (ARRO, BRIMO o Caporal - 1:00 h)",
        name: "Fase 2: Simulacre d'Entrevista (ARRO, BRIMO o Caporal - 1:00 h)",
        description: "Una prova real abans del dia real: posa’t a examen, detecta errors i arriba a l’entrevista amb seguretat i control.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        special_buy: "/tienda/cursos/fase2-simulacre-entrevista-arro-brimo-caporal-1-00h-2026/#reserva",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/1176/image1"],
        banner: ["/1176/image1"],
        link: "/tienda/cursos/fase2-simulacre-entrevista-arro-brimo-caporal-1-00h-2026/",
        created_at: "2026-02-15 00:00:01",
        start_at: "2026-02-15 00:00:01",
        more_info: true,
        items: 1,
        calendly_schedule: [
            {
                id: 1,
                name: "Marina",
                position: "Sergenta CME",
                description: "Acompanyament en processos selectius d'ascens i d'especialitat.",
                location: "C/ Martí Codolar, 18, 08902 L'Hospitalet de Llobregat (Barcelona)",
                link: "https://calendly.com/iopos-academia-marina/fase2-simulacre-entrevista-arro-brimo-2026-1-00-h-ho",
            },
        ],
    },
];
exports.default = products;
